const esc = (v) => {
  const s = v == null ? "" : String(v);
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

export function exportCsv(filename, columns, rows) {
  const header = columns.map((c) => esc(c.label)).join(",");
  const body = rows.map((r) => columns.map((c) => esc(c.value(r))).join(",")).join("\n");
  const blob = new Blob([`${header}\n${body}`], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${filename}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}

export function exportPdf(title, columns, rows, subtitle = "") {
  const head = columns.map((c) => `<th>${c.label}</th>`).join("");
  const body = rows
    .map(
      (r) =>
        `<tr>${columns.map((c) => `<td>${(c.value(r) ?? "").toString().replace(/</g, "&lt;")}</td>`).join("")}</tr>`
    )
    .join("");
  const win = window.open("", "_blank");
  if (!win) return;
  win.document.write(`<html><head><title>${title}</title><style>
    body{font-family:Manrope,Arial,sans-serif;padding:28px;color:#0f172a}
    h1{font-size:20px;margin:0 0 4px}p{color:#64748b;font-size:12px;margin:0 0 18px}
    table{width:100%;border-collapse:collapse;font-size:11px}
    th,td{border-bottom:1px solid #e2e8f0;padding:6px 8px;text-align:left}
    th{background:#f8fafc;text-transform:uppercase;font-size:9px;letter-spacing:.06em}
  </style></head><body><h1>${title}</h1><p>Veloskin Detailer Network${subtitle ? " · " + subtitle : ""} · ${new Date().toLocaleString("en-IN")}</p>
  <table><thead><tr>${head}</tr></thead><tbody>${body}</tbody></table>
  <script>window.onload=()=>window.print()<\/script></body></html>`);
  win.document.close();
}
